// extracted by css-extract-rspack-plugin
export default {"button_override":"EBIZN","buttonOverride":"EBIZN","#":"jTggY","icon":"RTO60","number":"olUkl","label":"FJw_R"};